import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { tabularTypeDatasetWithDatabaseAdapts } from './tabular-type.dataset.adapter';
import { SqlServerTableDatasetAdapter } from 'app/model/adapters/datasets/sql-server-table.dataset.adapter';
import { AmazonRdsSqlServerTableDataset } from 'app/model/dataset/amazon-rds-sql-server-table.dataset';
import { Model } from 'app/model/backendmodel';
import { GlobalVariables } from 'app/services/globals';

// almost the same as SqlServerTableDatasetAdapter
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonRdsSqlServerTableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetWithDatabaseAdapts,
        properties: {
            ...tabularTypeDatasetWithDatabaseAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForSql ? '*' : undefined
        }
    }
})
export class AmazonRdsSqlServerTableDatasetAdapter extends SqlServerTableDatasetAdapter {
    protected async _toResource(dataset: AmazonRdsSqlServerTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset,
            Metamodel.modelFor(AmazonRdsSqlServerTableDataset).name,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AmazonRdsSqlServerTableDataset.DATABASE : undefined);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AmazonRdsSqlServerTableDataset): Promise<AmazonRdsSqlServerTableDataset> {
        return await this._toModelInternal(modelDatasetResource,
            dataset,
            AmazonRdsSqlServerTableDataset.MODEL,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AmazonRdsSqlServerTableDataset.DATABASE : undefined
        );
    }
}
